// @core/api/endpoints/fiscalization/create_correction_receipt.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  CreateCorrectionReceiptRequest,
  CreateCorrectionReceiptResponse,
} from '../../../types/fiscalization';

const BASE_PATH = '/fiscalization';

/**
 * Create correction receipt
 * Creates a correction receipt to fix errors in previously issued receipts. Can be self-initiated or by tax authority order.
 */
export async function CreateCorrectionReceipt(
  data: CreateCorrectionReceiptRequest,
  options?: RequestOptions
): Promise<CreateCorrectionReceiptResponse> {
  const client = getApiClient();
  const requestPath = `${BASE_PATH}/fiscal-receipts/correction`;
  const requestOptions = options;
  return client.post<CreateCorrectionReceiptResponse>(requestPath, data, requestOptions);
}
